import ResponsiveLoading from 'components/ResponsiveLoading';
import AtolyeTable from './AtolyeTable';
import TablePagination from './TablePagination';
export default AtolyeTable;
export { ResponsiveLoading, TablePagination };
